module.exports = __webpack_public_path__ + "img/店铺排行5.7edc8d51.png";